export * from './ng4-files-click';
export * from './ng4-files-drop';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/components/index.ts